(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.subheader = document.querySelector('.section-subheader-row');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        if(this.subheader){
          this.subheader.parentElement.classList.add('shopify-section-header-sticky');
          // this.header.querySelector('sticky-header').classList.remove('header-wrapper--border-bottom');
          this.header.querySelectorAll('.global-settings-popup').forEach(element => {
            element.classList.add('remove-border-top')
          });

        }else{
          this.header.classList.add('shopify-section-header-sticky');
        }
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  // 检测桌面端导航是否换行
  function isMenuWrapped() {
    const items = document.querySelectorAll(
      'nav.header__inline-menu > ul > li'
    );

    if (items.length <= 1) return false;

    const firstTop = items[0].offsetTop;

    return [...items].some(item => item.offsetTop !== firstTop);
  }
  // 绑定hover和展开megamenu的动作
  const megaMenuHandlers = new WeakMap();
  function bindMouseOverToMegaMenu(item) {
    const menu = item.querySelector(".mega-menu__content");
    function onMouseOver() {
      item.setAttribute("open", "");
    }
    function onMenuEnter() {
      item.setAttribute("open", "");
    }
    function onMenuLeave() {
      item.removeAttribute("open");
    }
    function onItemLeave() {
      item.removeAttribute("open");
    }
    item.addEventListener("mouseover", onMouseOver);
    menu.addEventListener("mouseover", onMenuEnter);
    menu.addEventListener("mouseleave", onMenuLeave);
    item.addEventListener("mouseleave", onItemLeave);

    // 存起来方便解绑
    megaMenuHandlers.set(item, {
      onMouseOver,
      onMenuEnter,
      onMenuLeave,
      onItemLeave,
    });
  }
  function unbindMouseOverFromMegaMenu(item) {
    const menu = item.querySelector(".mega-menu__content");
    const handlers = megaMenuHandlers.get(item);

    if (!handlers) return;

    item.removeEventListener("mouseover", handlers.onMouseOver);
    menu.removeEventListener("mouseover", handlers.onMenuEnter);
    menu.removeEventListener("mouseleave", handlers.onMenuLeave);
    item.removeEventListener("mouseleave", handlers.onItemLeave);

    megaMenuHandlers.delete(item);
  }

  function updateMegaMenuHover() {
    const items = document.querySelectorAll("details.mega-menu");
    const wrapped = isMenuWrapped();
    items.forEach(item => {
      const isBound = megaMenuHandlers.has(item);
      if (wrapped && isBound) {
        unbindMouseOverFromMegaMenu(item);
      } else if (!wrapped && !isBound) {
        bindMouseOverToMegaMenu(item);
      }
    });
  }

  window.addEventListener("resize", updateMegaMenuHover);
  //updateMegaMenuHover();
  //const css = document.querySelector('link[href*="component-menu-with-images-cudy.css"]');
  //if (css.sheet) {
    updateMegaMenuHover();
  //} else {
    //css.addEventListener('load', updateMegaMenuHover, { once: true });
  //}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-cudy"]) return;
  try {
    
// 以下代码将从飞书文档复制而来的表格加上避免折叠的最小宽度class
// 以上代码将从飞书文档复制而来的表格加上避免折叠的最小宽度class
document.querySelectorAll('div > .ace-table').forEach(function(el) {
  el.parentElement.classList.add('ace-table-wrapper');
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid-cudy"]) return;
  try {
    
  let compareCheckboxes,
    compareToolBar,
    productsToCompare,
    productToCompareDemo,
    compareNum,
    compareButton,
    compareUrl,
    clearAllButton,
    compareDataHandle,
    maximumCompareAlert,
    compareList;
    
  window.addEventListener('DOMContentLoaded', ()=>{
    initializeCompareUI();
    readCompareListFromSessionStorage()});


  function initializeCompareUI() {
    compareCheckboxes = document.querySelectorAll('.compare-checkbox input[type="checkbox"]');
    compareToolBar = document.querySelector('#compare-toolbar')
    if (compareToolBar) {
      productsToCompare = compareToolBar.querySelector('.products-to-compare');
      productToCompareDemo = compareToolBar.querySelector('.product-to-compare.demo');
      compareNum = compareToolBar.querySelector('#product-to-compare-number');
      compareButton = compareToolBar.querySelector('#compare');
      compareUrl = compareButton.dataset.defaultHref
      clearAllButton = compareToolBar.querySelector('#clear-all');
      compareDataHandle = 'compareListOf' + window.location.pathname;
      maximumCompareAlert = compareToolBar.querySelector('.maximum-compare-alert')
    }
    if (compareCheckboxes) {
      compareCheckboxes.forEach(checkbox => {
        if (checkbox.checked) {checkbox.checked = false};
        checkbox.addEventListener('change', () => updateCompareListSessionStorage(checkbox));
      });
    }

    if (clearAllButton) {
      clearAllButton.addEventListener('click', clearAllCompareProduct);
    }

  }

  function readCompareListFromSessionStorage(){
    compareList = JSON.parse(sessionStorage.getItem(compareDataHandle));
    if (compareList && compareList.length > 0) {
      updateCompareCheckBoxes();
      updateCompareButtonGroup();
    } else {
      clearAllCompareProduct();
    }
  }

  // Optional: expose it globally so JS modules can call it


  function updateCompareListSessionStorage(checkbox = undefined, product = undefined) {
    compareList = JSON.parse(sessionStorage.getItem(compareDataHandle)) || [];
// 如果未傳入Product值，則取有變化的checbox作爲Product值
    if (! product) {
      product = {
        name: checkbox.name,
        value: checkbox.value,
        dataUrl: checkbox.dataset.productUrl,
        dataImgSrc: checkbox.dataset.imgSrc
      }
    }

// 將checkbox觸發的新增推入compareList（也是首次載入讀取Session之外，用戶唯一一種加產品的方式）
    if (checkbox && checkbox.checked) { // Add the checked checkbox to the end of the array
      if (compareList.length < 4) {
        compareList.push(product);
        addCompareProductToBar(product)
      } else {
        alert(maximumCompareAlert.innerText)
        checkbox.checked = false
        return
      }
    } else { // Remove the unchecked checkbox to to be removed product from the array
      compareList = compareList.filter(item => item.value !== product.value);

// 對於不是checkbox觸發的更新，只可能是消除，要去掉tool bar中的產品
      if (checkbox) {
        removeCompareProductFromBar(product)
      }
    }

// Update the session storage with the new array
    sessionStorage.setItem(compareDataHandle, JSON.stringify(compareList));

// Update the Button DOM Accordingly
    updateCompareButtonGroup()
  }


  function addCompareProductToBar(product) {
    let newCompare = productToCompareDemo.cloneNode(true);
    newCompare.classList.remove('demo');
    newCompare.classList.add(product.value);
    newCompare.querySelector('img').src = product.dataImgSrc;
    newCompare.querySelector('img').alt = product.name;
    newCompare.querySelector('.model-version').innerText = product.name;
    newCompare.querySelector('.product-link').href = product.dataUrl;
    let ariaLabel = newCompare.querySelector('.product-link').getAttribute('aria-label') + product.name;
    newCompare
      .querySelector('.product-link')
      .setAttribute('aria-label', ariaLabel)
      newCompare
      .querySelector('.remove-button')
      .addEventListener('click', () => {
        removeCompareProductFromBar(product)
      });
    productsToCompare.appendChild(newCompare);
  }

  function removeCompareProductFromBar(product) {
    productToRemove = productsToCompare.querySelector("." + product.value);
    if (productToRemove) {
      productToRemove.remove()
    };
    relatedCheckbox = document.querySelector('.compare-checkbox input[type="checkbox"][value="' + product.value + '"]');
    if (relatedCheckbox && relatedCheckbox.checked == true) {
      relatedCheckbox.checked = false;
      updateCompareListSessionStorage(relatedCheckbox)
    } else {
      updateCompareListSessionStorage(null, product)
    }
  }
  function updateCompareCheckBoxes(updateBar = true){
    compareList.forEach(product => {
      let onCurrentPage = false;
      for (let i = 0; i < compareCheckboxes.length; i++) {
        const checkbox = compareCheckboxes[i];
        if (checkbox.value == product.value) {
          checkbox.checked = true;
          onCurrentPage = true;
          break;
        }
      }
      if (updateBar){
        addCompareProductToBar(product);
      }
    })
  }
  function updateCompareButtonGroup() {
    compareNum.innerText = compareList.length;
    if (compareList.length < 2) {
      compareButton.classList.add('unclickable')
    } else {
      compareButton.classList.remove('unclickable')
    }
    let compareUrlAnchor = compareList.map(product => product.value).join('&');
    compareButton.href = compareUrl + "#models=" + compareUrlAnchor;
  }

  function clearAllCompareProduct() {
    compareCheckboxes.forEach(checkbox => {
      if (checkbox.checked == true) {
        checkbox.checked = false
      }
      sessionStorage.removeItem(compareDataHandle);
      productsToCompare.querySelectorAll('.product-to-compare:not(.demo)').forEach(element => {
        element.remove()
      })
    })
  }

  window.updateComparingModuleAfterFacetRendering = function(updateBar = false) {
    initializeCompareUI();
    updateCompareCheckBoxes(updateBar);
  };


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-compare"]) return;
  try {
    
  const compareTable = document.querySelector("#compare-table");
  const compareTbody = compareTable.querySelector("tbody");
  const hardware = compareTable.querySelector("#hardware-section");
  const software = compareTable.querySelector("#software-section");
  const highlightToggle = document.querySelector("#highlight-toggle");
  const highlightToggleBox = document.querySelector(".highlight-toggle-box");
  const mainDimensionTh = compareTable.querySelectorAll('th.main-dimension, th.spec-category');
  const secondaryDimensionTh = compareTable.querySelectorAll('th.secondary-dimension');

  let hasImgInModelRow = false;

  document.addEventListener('DOMContentLoaded', function() {

    const currentHash = window.location.hash;
    if (currentHash.indexOf('models=') != -1) {
      const modelsToCompare = currentHash.split('=')[1].split('&');
      const modelsToCompareInStdName = [];
      const modelsNum = modelsToCompare.length;
      widenCellWidth(modelsNum + 1);
      readStandardModelVersion(modelsToCompare, modelsToCompareInStdName);
      displayComparingProducts(modelsToCompare, modelsToCompareInStdName);

      const modelCells = Array.from(
        compareTbody.querySelector(".model-version-row")
          .querySelectorAll("td:not([hidden])")
      );

      if (modelCells.length >= 3) {
        modelCells.forEach(td => {
          const handle = document.createElement("div");
          handle.classList.add("drag-handle");
          handle.innerHTML = `<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <circle cx="5" cy="4" r="1.5"/><circle cx="11" cy="4" r="1.5"/>
            <circle cx="5" cy="8" r="1.5"/><circle cx="11" cy="8" r="1.5"/>
            <circle cx="5" cy="12" r="1.5"/><circle cx="11" cy="12" r="1.5"/>
          </svg>`;
          td.appendChild(handle);
        });
      }

      hideEmptyRow();
    }

    if (highlightToggle){
      highlightToggle.addEventListener('change', toggleHighlight);
    }

    let imgRow = compareTable.querySelector('.model-version-row');
    compareTbody.insertBefore(imgRow, compareTbody.firstChild);

    constructMobileTable();

    compareTbody.querySelectorAll('tr:has(th.main-dimension):not([hidden])').forEach(tr => {
      tr.addEventListener('click', toggleSiblingDimensionRows);
    });
    compareTbody.querySelectorAll('tr:has(th.secondary-dimension):not([hidden])').forEach(tr => {
      tr.addEventListener('click', toggleSiblingValueRows);
    });

    // 推迟到下一帧执行，减少 DOMContentLoaded 同步耗时
    requestAnimationFrame(() => {
      updateColspan();
      updateStickyTop();

      hasImgInModelRow = Array.from(imgRow.querySelectorAll("td:not([hidden='true'])"))
        .some(child => child.querySelector("img"));
      if(highlightToggleBox){
        if (hasImgInModelRow) {
          highlightToggleBox.style.top = '80px';
        } else {
          highlightToggleBox.style.top = '75px';
        }
        highlightToggleBox.removeAttribute("hidden");
      }
      
    });

    window.addEventListener('resize', updateColspan);
    window.addEventListener('resize', updateStickyTop);
    window.addEventListener('scroll', updateStickyTop, { passive: true });
  });

  function widenCellWidth(colspan) {
    if (hardware) hardware.setAttribute("colspan", colspan);
    if (software) software.setAttribute("colspan", colspan);
    compareTable.querySelectorAll(".main-dimension").forEach(element => element.setAttribute("colspan", colspan));
  }

  function readStandardModelVersion(modelsToCompare, modelsToCompareInStdName) {
    modelsToCompare.forEach(model => {
      let standardModelVersion = compareTable.querySelector("tr.model-version-row").querySelector("." + model).textContent.trim();
      modelsToCompareInStdName.push(standardModelVersion);
    });
  }

  function displayComparingProducts(modelsToCompare, modelsToCompareInStdName) {
    let sequence = 0;
    modelsToCompare.forEach(model => {
      compareTable.querySelectorAll("." + model).forEach(element => {
        if (element.textContent.indexOf("N/T Main Product") != -1) {
          let pkgListings = element.querySelectorAll("li");
          if (pkgListings) {
            pkgListings.forEach(listing => {
              if (listing.textContent === "N/T Main Product") {
                listing.textContent = modelsToCompareInStdName[sequence];
                sequence += 1;
              }
            });
          }
        }
        element.removeAttribute('hidden');
      });
    });
  }

  function replaceNTmodel(modelsToCompare) {
    modelsToCompare.forEach(model => {
      compareTable.querySelectorAll("." + model).forEach(element => element.removeAttribute('hidden'));
    });
  }

  function hideEmptyRow() {
    const allRows = compareTable.querySelectorAll("tr");
    let lastSpecCategory, lastSCToBeHidden, lastMainRow, lastMainToBeHidden;

    for (let i = 0; i < allRows.length; i++) {
      const row = allRows[i];
      if (row.querySelector('th.main-dimension')) {
        lastMainRow = row;
        lastMainToBeHidden = true;
      } else if (row.querySelector('th.spec-category')) {
        lastSpecCategory = row;
        lastSCToBeHidden = true;
      } else if (row.querySelector('th.secondary-dimension')) {
        let secondaryToBeHidden = false;
        const specValues = row.querySelectorAll("td:not([hidden])");
        if (specValues && specValues.length != 0) {
          const getCellValue = (td) => {
            if (td.querySelector('svg')) return '__SVG__';
            return td.textContent.trim();
          };

          let firstValue = getCellValue(specValues[0]);
          for (let j = 1; j < specValues.length; j++) {
            if (getCellValue(specValues[j]) != firstValue) {
              row.classList.add("different-specs-row");
              secondaryToBeHidden = false;
              lastMainToBeHidden = lastSCToBeHidden = false;
              break;
            } else {
              if (firstValue == "-" || firstValue.toLowerCase() == "false" || firstValue.length == 0) {
                secondaryToBeHidden = true;
              } else {
                lastMainToBeHidden = lastSCToBeHidden = false;
              }
            }
          }
        } else {
          secondaryToBeHidden = true;
        }

        if (secondaryToBeHidden) row.setAttribute("hidden", "true");

        const nextRow = row.nextElementSibling;
        if (!nextRow) {
          if (lastMainToBeHidden) lastMainRow.setAttribute("hidden", "true");
          if (lastSCToBeHidden) lastSpecCategory.setAttribute("hidden", "true");
        } else {
          if (!nextRow.querySelector('th.secondary-dimension')) {
            if (lastMainToBeHidden) lastMainRow.setAttribute("hidden", "true");
            if (!nextRow.querySelector('th.main-dimension') && lastSCToBeHidden) {
              lastSpecCategory.setAttribute("hidden", "true");
            }
          }
        }
      }
    }
  }

  function toggleHighlight() {
    const rows = compareTable.querySelectorAll('tr.different-specs-row');
    rows.forEach(row => {
      if (highlightToggle.checked) {
        row.classList.add('highlight');
      } else {
        row.classList.remove('highlight');
      }
    });
  }

  function constructMobileTable() {
    const models = [];
    compareTbody.querySelector(".model-version-row").querySelectorAll("td:not([hidden])").forEach(modelCell => {
      models.push(modelCell.textContent.trim());
    });

    const allDesktopRows = compareTbody.querySelectorAll("tr:has(th.secondary-dimension):not(.model-version-row):not([hidden])");
    allDesktopRows.forEach(row => {
      row.classList.add('hidden-by-main-dimension-on-mobile');
      const insertRows = [];
      for (let i = 0; i < models.length; i++) {
        const newRow = document.createElement('tr');
        const newHeader = document.createElement('th');
        newRow.classList.add('table-row-mobile', 'hidden-by-secondary-dimension-on-mobile', 'hidden-by-main-dimension-on-mobile');
        if (row.classList.contains("different-specs-row")) {
          newRow.classList.add('different-specs-row');
        }
        newHeader.textContent = models[i];
        newHeader.classList.add('secondary-dimension-mobile');
        newRow.appendChild(newHeader);

        const existingCell = row.querySelectorAll("td:not([hidden])")[i];
        let newTableData;
        if (existingCell) {
          newTableData = existingCell.cloneNode(true);
        } else {
          newTableData = document.createElement('td');
          newTableData.classList.add('spec-value');
        }
        newTableData.classList.add('spec-value-mobile');
        newRow.appendChild(newTableData);
        insertRows.push(newRow);
      }
      // 批量插入，减少 reflow
      insertRows.reverse().forEach(newRow => {
        compareTbody.insertBefore(newRow, row.nextSibling);
      });
    });
  }

  function toggleSiblingDimensionRows(event) {
    const currentRow = event.currentTarget;
    const isUnfold = currentRow.dataset.mobileUnfold === 'true';
    currentRow.dataset.mobileUnfold = isUnfold ? 'false' : 'true';
    let nextRow = currentRow.nextElementSibling;
    while (nextRow && !nextRow.querySelector('th.main-dimension') && !nextRow.querySelector('th.spec-category')) {
      nextRow.classList.toggle('hidden-by-main-dimension-on-mobile');
      nextRow = nextRow.nextElementSibling;
    }
  }

  function toggleSiblingValueRows(event) {
    const currentRow = event.currentTarget;
    const isUnfold = currentRow.dataset.mobileUnfold === 'true';
    currentRow.dataset.mobileUnfold = isUnfold ? 'false' : 'true';
    let nextRow = currentRow.nextElementSibling;
    while (nextRow && !nextRow.querySelector('th.secondary-dimension') && !nextRow.querySelector('th.main-dimension')) {
      nextRow.classList.toggle('hidden-by-secondary-dimension-on-mobile');
      nextRow = nextRow.nextElementSibling;
    }
  }

  function updateColspan() {
    const models = [];
    compareTbody.querySelector(".model-version-row").querySelectorAll("td:not([hidden])").forEach(modelCell => {
      models.push(modelCell.textContent.trim());
    });
    const maxMobileWidth = 767;
    if (window.innerWidth <= maxMobileWidth) {
      secondaryDimensionTh.forEach(th => th.setAttribute('colspan', '2'));
      mainDimensionTh.forEach(th => th.setAttribute('colspan', '2'));
    } else {
      secondaryDimensionTh.forEach(th => th.setAttribute('colspan', '1'));
      mainDimensionTh.forEach(th => th.setAttribute('colspan', models.length + 1));
    }
  }

function updateStickyTop() {
  const header = document.querySelector('sticky-header');
  const top = header
    ? Math.max(0, Math.round(header.getBoundingClientRect().bottom))
    : 60;

  compareTable.querySelectorAll('.model-version-row th, .model-version-row td').forEach(el => {
    el.style.top = (top - (hasImgInModelRow ? 145 : 0)) + 'px';
  });
}

  // 拖拽排序

  let dragColIndex = null;
  let targetColIndex = null;
  let activeHandle = null;
  let activeCell = null;
  let isDragging = false;
  let rafId = null;
  let cachedRects = [];

  compareTable.addEventListener("mousedown", e => {
    const handle = e.target.closest(".drag-handle");
    if (!handle) return;

    const cell = handle.closest("td");
    if (!cell) return;
    const row = cell.parentElement;
    if (!row.classList.contains("model-version-row")) return;

    const visibleCells = Array.from(row.children).filter(
      c => c.getAttribute("hidden") !== "true"
    );
    dragColIndex = visibleCells.indexOf(cell);
    if (dragColIndex <= 0 || dragColIndex === -1) return;

    e.preventDefault();
    isDragging = true;
    cachedRects = visibleCells.map(c => c.getBoundingClientRect());
    document.body.style.userSelect = "none";
    activeHandle = handle;
    activeCell = cell;
    handle.classList.add("dragging");
    document.body.classList.add("dragging-col");
    document.addEventListener("mousemove", onDragMove);
    document.addEventListener("mouseup", onDragEnd);
  });

  function onDragMove(e) {
    if (!isDragging) return;
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;

      const refRow = compareTable.querySelector("tr.model-version-row");
      const visibleCells = Array.from(refRow.children).filter(
        c => c.getAttribute("hidden") !== "true"
      );

      let newIndex = visibleCells.length - 1;
      for (let i = 1; i < cachedRects.length; i++) {
        const rect = cachedRects[i];
        if (e.clientX >= rect.left && e.clientX < rect.left + rect.width) {
          newIndex = i;
          break;
        }
      }
      if (e.clientX >= cachedRects[cachedRects.length - 1].left + cachedRects[cachedRects.length - 1].width) {
        newIndex = cachedRects.length - 1;
      }
      targetColIndex = Math.max(1, newIndex);

      visibleCells.forEach(c => c.style.backgroundColor = "#ffffff");
      if (visibleCells[targetColIndex]) {
        visibleCells[targetColIndex].style.backgroundColor = "#eaeaea";
      }
    });
  }

  function onDragEnd(e) {
    document.removeEventListener("mousemove", onDragMove);
    document.removeEventListener("mouseup", onDragEnd);
    document.body.classList.remove("dragging-col");

    if (rafId) {
      cancelAnimationFrame(rafId);
      let dropIndex = cachedRects.length - 1;
      for (let i = 1; i < cachedRects.length; i++) {
        const rect = cachedRects[i];
        if (e.clientX >= rect.left && e.clientX < rect.left + rect.width) {
          dropIndex = i;
          break;
        }
      }
      if (e.clientX >= cachedRects[cachedRects.length - 1].left + cachedRects[cachedRects.length - 1].width) {
        dropIndex = cachedRects.length - 1;
      }
      targetColIndex = Math.max(1, dropIndex);
      rafId = null;
    }

    document.body.style.userSelect = "";
    isDragging = false;

    if (dragColIndex === null) {
      cleanupHighlight();
      return;
    }

    const dropIndex = targetColIndex;
    if (dropIndex !== null && dropIndex !== dragColIndex) {
      moveColumn(compareTable, dragColIndex, dropIndex);
    }

    if (activeHandle) {
      activeHandle.classList.remove("dragging");
      activeHandle = null;
    }
    cleanupHighlight();
    cachedRects = [];
    dragColIndex = null;
    targetColIndex = null;
  }

  function moveColumn(table, fromIndex, toIndex) {
    table.querySelectorAll("tr").forEach(row => {
      const visibleCells = Array.from(row.children).filter(
        c => c.getAttribute("hidden") !== "true"
      );
      if (visibleCells.length < Math.max(fromIndex, toIndex) + 1) return;
      const fromCell = visibleCells[fromIndex];
      const toCell = visibleCells[toIndex];
      if (fromIndex < toIndex) {
        row.insertBefore(fromCell, toCell.nextSibling);
      } else {
        row.insertBefore(fromCell, toCell);
      }
    });
  }

  function cleanupHighlight() {
    const refRow = compareTable.querySelector("tr.model-version-row");
    if (!refRow) return;
    Array.from(refRow.children)
      .filter(c => c.getAttribute("hidden") !== "true")
      .forEach(c => c.style.backgroundColor = "#ffffff");
  }
  // function updateStickyTop() {
  //   const header = document.querySelector('sticky-header');
  //   const top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 60;
  //   document.querySelectorAll('.model-version-row th, .model-version-row td').forEach(el => {
  //     el.style.top = top + 'px';
  //   });
  // }

  // updateStickyTop();
  // window.addEventListener('scroll', updateStickyTop, { passive: true });
  // window.addEventListener('resize', updateStickyTop);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-cudy"]) return;
  try {
    
  const carousels = document.querySelectorAll('.image-carousel');
  carousels.forEach(carousel => {
    const images = carousel.querySelectorAll('li');
    let currentIndex = 0;

    function showImage(index) {
      images.forEach((image, i) => {
        image.classList.remove('active');
        if (i === index) {
          image.classList.add('active');
          image.classList.remove('outgoing');
        }
      });
    }

    function nextImage() {
      const previousIndex = currentIndex;
      currentIndex = (currentIndex + 1) % images.length;

      images[previousIndex].classList.add('outgoing');

      showImage(currentIndex);
    }
    // Initial display
    showImage(currentIndex);

    // Automatic slide show (adjust interval as needed)
    setInterval(nextImage, 5000);
  });


  function openModal(element, modalBox, triggerToAvoid, video){
    element.removeAttribute("hidden");
    if (!document.body.classList.contains('overflow-hidden-tablet')) {
      document.body.classList.add('overflow-hidden-mobile');
    }
    window.addEventListener('click', (event) => clickOutsideModal(event, element, modalBox, triggerToAvoid, video));
  }

  function closeModal(element, video){
    element.setAttribute('hidden', true);
    document.body.classList.remove('overflow-hidden-mobile');
    if (video) {
      video.pause()
    }
  }

  function clickOutsideModal(event, element, modalBox, triggerToAvoid, video){
    if (event.target != modalBox && !modalBox.contains(event.target) && !triggerToAvoid.contains(event.target)){
      closeModal(element, video)
      window.removeEventListener('click', clickOutsideModal)
    }
  }

  const unfoldCtaButtons = document.querySelectorAll('a[data-trigger-method="cta-manual-unfold"]');

  unfoldCtaButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const banner = button.closest('div[data-banner-id]');
      const relatedModalId = button.getAttribute('data-related-modal-id');
      const relatedModal = document.querySelector(`div[data-modal-id="${relatedModalId}"]`);
      const modalBox = relatedModal.querySelector(".modal-box")
      const modalCloseIcon = relatedModal.querySelector(".close-model-finder-modal")
      const video = relatedModal.querySelector("video");
      openModal(relatedModal, modalBox, button, video);
      if (video) {
        video.play();
      }
      modalCloseIcon.addEventListener('click', function(event){
        event.preventDefault();
        closeModal(relatedModal, video)

      });
    });
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-detail-section-cudy"]) return;
  try {
    

function assignLink(row, class_name, link){
  let all_imgs = row.querySelectorAll('img[class*="icons-' + class_name+ '"], img[class*="img-' + class_name + '"]')
  if(all_imgs.length > 0){
    all_imgs.forEach((img)=>{
      img.classList.add("clickable");
      img.addEventListener("click", function() {
        window.location.href = link
      })
    })
  }
}

const class_array = ["i-link","ii-link","iii-link","iv-link"]
const feature_rows = document.querySelectorAll(".feature-row")
feature_rows.forEach(function(row){
  class_array.forEach(function(class_name){
    let link_element = row.querySelector("."+ class_name)
    if( link_element ){
      let the_url = link_element.textContent
      assignLink(row, class_name, the_url)
    }
  })
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-info-switch-cudy"]) return;
  try {
    
  const features_button = document.querySelector('#product-info-switch-features-button');
  const specs_button = document.querySelector('#product-info-switch-specs-button');
  const features_content = document.querySelector('[id*="main-amazon-a-plus"]');
  const specs_content = document.querySelector('[id*="main-spec-sheet"]');

    // Function to show content A and hide content B
    function showFeatures() {
      if (features_content) {
        features_content.classList.remove('hidden-by-switcher');
        features_button.classList.add("highlighted")
      }
      if(specs_content){
        specs_content.classList.add('hidden-by-switcher');
        specs_button.classList.remove("highlighted")
      }
    }

    // Function to show content B and hide content A
    function showSpecs() {
      if(features_content){
        features_content.classList.add('hidden-by-switcher');
        features_button.classList.remove("highlighted")
      };
      if (specs_content){
        specs_content.classList.remove('hidden-by-switcher');
        specs_button.classList.add("highlighted")
      }
    }

    // Set up event listeners for button clicks
    if(features_button){
      features_button.addEventListener('click', showFeatures);
    };
    if(specs_button){
      specs_button.addEventListener('click', showSpecs);
    }

    // Check the URL for anchor text and show corresponding content
    window.addEventListener('DOMContentLoaded', function() {
      const urlHash = window.location.hash;
      if (urlHash === '#specs' && specs_button) {
        showSpecs();
      } else if (features_button)   {
        showFeatures(); // Default to content A
      } else {
        showSpecs();
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-subheader-cudy"]) return;
  try {
    
  const overview_button = document.querySelector('#overview-button');
  const features_button = document.querySelector('#features-button');
  const specs_button = document.querySelector('#specs-button');
  const overview_content = document.querySelector('#main-amazon-a-plus-details');
  const features_content = document.querySelector('#main-product-cudy-details');
  const specs_content = document.querySelector('#main-spec-sheet-details');
  const current_path = window.location.pathname;

  function toggleContent(contentToDisplay, contentsToHide, buttonToActive, buttonsToDeactive, recordScroll, restoreScroll = true) {
    buttonsToDeactive.forEach(element => {
      if (element) element.classList.remove("active");
    });
    buttonToActive.classList.add("active");

    let subheaderLeftScroll = document.querySelector(".subheader-left").getBoundingClientRect().top;
    let headerHeight = document.querySelector("header").clientHeight;
    let topSpaceScroll = headerHeight - subheaderLeftScroll + 1;

    contentsToHide.forEach(element => {
      if (element && element.hasAttribute("open")) {
        if (recordScroll) {
          let currentSectionScroll = window.pageYOffset || document.documentElement.scrollTop;
          sessionStorage.setItem(current_path + "_" + element.id + "_scroll", currentSectionScroll);
        }
        element.removeAttribute("open");
      }
    });

    contentToDisplay.setAttribute("open", "");

    if (restoreScroll && recordScroll) {
      let sectionToScrollString = sessionStorage.getItem(current_path + "_" + contentToDisplay.id + "_scroll");
      let sectionToScroll = parseFloat(sectionToScrollString);
      if (sectionToScroll) {
        window.scrollTo({ top: sectionToScroll });
      } else {
        window.scrollTo({ top: topSpaceScroll });
      }
    }
  }

  function showOverview(recordScroll = true, restoreScroll = true) {
    toggleContent(overview_content, [specs_content, features_content], overview_button, [specs_button, features_button], recordScroll, restoreScroll);
  }

  function showFeatures(recordScroll = true, restoreScroll = true) {
    toggleContent(features_content, [overview_content, specs_content], features_button, [overview_button, specs_button], recordScroll, restoreScroll);
  }

  function showSpecs(recordScroll = true, restoreScroll = true) {
    toggleContent(specs_content, [overview_content, features_content], specs_button, [overview_button, features_button], recordScroll, restoreScroll);
  }

  function pageSwitcher(recordScroll = false) {
    const urlHash = window.location.hash;
    if (urlHash === '#specs' && specs_button) {
      showSpecs(recordScroll);
    } else if (urlHash === '#features' && features_button) {
      showFeatures(recordScroll);
    } else if (overview_button) {
      showOverview(recordScroll);
    } else {
      showFeatures(recordScroll);
    }
  }


  if (features_button) features_button.addEventListener('click', showFeatures);
  if (overview_button) overview_button.addEventListener('click', showOverview);
  if (specs_button) specs_button.addEventListener('click', showSpecs);

  window.addEventListener('DOMContentLoaded', function() {
    pageSwitcher();
  });

  window.addEventListener('popstate', () => {
    pageSwitcher(true);
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-subheader-s-cudy"]) return;
  try {
    


  let crumbItemCollection = document.querySelector("#crumb-item-collection");

// let crumbItemProducts  = document.querySelector("#crumb-item-products");
  let crumbWrapper = document.querySelector("#crumb-wrapper");
  let highlightedCrumb = document.querySelector(".highlighted").parentNode;
  let parentOfCrumbWrapper = crumbWrapper.parentNode
  let crumbCaret = document.querySelector("#crumb-item-collection").querySelector(".icon-caret");

  function startScroll(direction, container) {
    scrollInterval = setInterval(function() {
      container.scrollBy({
        left: direction * 25, // Adjust scrolling speed here
        behavior: 'smooth'
      });
    }, 50); // Adjust scrolling interval here
  }function stopScroll() {
    clearInterval(scrollInterval);
  }

  let beforeWidth = crumbItemCollection.clientWidth + crumbItemCollection.getBoundingClientRect().left
  if (highlightedCrumb) {
    let highlightedCrumPosition = highlightedCrumb.offsetLeft;
    crumbWrapper.scrollLeft = highlightedCrumPosition - beforeWidth;
  }
  crumbItemCollection.addEventListener('mouseenter', function(event) {
    let target = event.target;

// Check if the mouse entered the left or right gradient overlay
    if (target.matches('.crumb-item-collection::after')) {
      startScroll(-1, crumbWrapper)
    }
  });

// crumbCaret.addEventListener('mouseenter', function(event) {
// crumbWrapper.scrollBy({left:-100,behavior:"smooth"})
// })

  crumbCaret.addEventListener('mouseenter', function(event) {
    startScroll(-1, crumbWrapper)
  })
  crumbCaret.addEventListener('mouseout', function(event) {
    stopScroll()
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-subheader-t-cudy"]) return;
  try {
    
  // const overview_button = document.querySelector('#overview-button');
  const features_button = document.querySelector('#features-button');
  const specs_button = document.querySelector('#specs-button');
  const overview_content = document.querySelector('#main-amazon-a-plus-details');
  const features_content = document.querySelector('#main-product-cudy-details');
  const specs_content = document.querySelector('#main-spec-sheet-details');
  const current_path = window.location.pathname;
  function toggleContent(contentsToDisplay, contentsToHide, buttonToActive, buttonsToDeactive, recordScroll, restoreScroll = true) {
    buttonsToDeactive.forEach(element => {
      if (element) {
        element.classList.remove("active")
      }
    })
    buttonToActive.classList.add("active");

    let subheaderLeftScroll = document.querySelector(".subheader-left").getBoundingClientRect().top;
    let headerHeight = document.querySelector("header").clientHeight;
    let topSpaceScroll = headerHeight - subheaderLeftScroll + 1;
    contentsToHide.forEach(element => {
      if (element && element.hasAttribute("open")) {
        if (recordScroll) {
          let currentSectionScroll = window.pageYOffset || document.documentElement.scrollTop;
          sessionStorage.setItem(current_path + "_" + element.id + "_scroll", currentSectionScroll);
        }
        element.removeAttribute("open");
      }
    });

    contentsToDisplay.forEach(element => {
      if (element && !element.hasAttribute("open")) {
        element.setAttribute("open", "");
      }
    });

    if (restoreScroll && recordScroll) {
      let sectionToScrollString = sessionStorage.getItem(current_path + "_" + contentsToDisplay[0].id + "_scroll");
      let sectionToScroll = parseFloat(sectionToScrollString);
      if (sectionToScroll) {
        window.scrollTo({ top: sectionToScroll });
      } else {
        window.scrollTo({ top: topSpaceScroll });
      }
    }
  }

  function showFeatures(recordScroll = true) {
    let contentsToDisplay = [overview_content, features_content]
    let contentsToHide = [specs_content]
    let buttonToDeactive = [specs_button]
    toggleContent(contentsToDisplay, contentsToHide, features_button, buttonToDeactive, recordScroll)
  }

  function showSpecs(recordScroll = true) {
    let contentsToDisplay = [specs_content]
    let contentsToHide = [overview_content, features_content]
    let buttonToDeactive = [features_button]
    toggleContent(contentsToDisplay, contentsToHide, specs_button, buttonToDeactive, recordScroll)
  }

  function pageSwitcher(recordScroll = false) {
    const urlHash = window.location.hash;
    if (urlHash === '#specs' && specs_button) {
      showSpecs(recordScroll);
    } else {
      showFeatures(recordScroll)
    }
  }


  if (features_button) {
    features_button.addEventListener('click', showFeatures);
  };
  if (specs_button) {
    specs_button.addEventListener('click', showSpecs);
  }
  window.addEventListener('DOMContentLoaded', function() {
    pageSwitcher()
  })

  window.addEventListener('popstate', () => {
    pageSwitcher(true)
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-spec-sheet-cudy"] && !Shopify.designMode) return;
  try {
    
    const hardware_button = document.querySelector('#hardware-spec-button');
  const software_button = document.querySelector('#software-button-button');
  const hardware_content = document.querySelector('#hardware-spec-table');
  const software_content = document.querySelector('#software-spec-table');

  function showHardware() {
    if (hardware_content) {
      hardware_content.classList.remove('folded');
      if (hardware_button) hardware_button.classList.add("highlighted");
    }
    if (software_content) {
      software_content.classList.add('folded');
      if (software_button) software_button.classList.remove("highlighted");
    }
  }

  function showSoftware() {
    if (hardware_content) {
      hardware_content.classList.add('folded');
      if (hardware_button) hardware_button.classList.remove("highlighted");
    }
    if (software_content) {
      software_content.classList.remove('folded');
      if (software_button) software_button.classList.add("highlighted");
    }
  }

  if (hardware_button) hardware_button.addEventListener('click', showHardware);
  if (software_button) software_button.addEventListener('click', showSoftware);
  if (hardware_content) showHardware(); // ← moved out of DOMContentLoaded


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-redirect"]) return;
  try {
    
  function getRedirectLinkFromLiquid(p) {
    let link = document.querySelector("." + p + "-link").getAttribute('href');
    let alert_text = document.querySelector("." + p + "-alert").textContent;
    return {link: link, alert_text: alert_text}
  }
  const platform = ["ios", "android", "general"];
  let redirect_dst = [];
  platform.forEach((p) => {
    let result = getRedirectLinkFromLiquid(p)
    redirect_dst.push(result)
    console.log(result)
  })
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/android/i.test(userAgent) && redirect_dst[1].link) { // 如果是 Android 设备
    if (redirect_dst[1].alert_text) {
      alert(redirect_dst[1].alert_text);
    }
    if (redirect_dst[1].link) {
      window.location.href = redirect_dst[1].link;
    }
  } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream && redirect_dst[0].link) { // 如果是 iOS 设备
    if (redirect_dst[0].alert_text) {
      alert(redirect_dst[0].alert_text)
    }
    if (redirect_dst[0].link) {
      window.location.href = redirect_dst[0].link;
    }
  } else {
    if (redirect_dst[2].alert_text) {
      alert(redirect_dst[2].alert_text);
    }
    if (redirect_dst[2].link) {
      window.location.href = redirect_dst[2].link;
    }
  }

  } catch(e) { console.error(e); }
})();
})();
